/**
 * Danh sách gói custom (giao diện). Thêm khách: tạo `src/custom/<ten-khach>/index.ts` theo mẫu
 * `_mau/` rồi thêm vào mảng dưới (xem docs/huong-dan-goi-custom.md).
 */
import type { GoiCustomFE, RouteCustom } from './cong'
import type { NavItem } from '@/components/shared/nav-config'
import traDuocVietNam from './tra-duoc-viet-nam'

export const DANH_SACH_GOI_CUSTOM_FE: GoiCustomFE[] = [traDuocVietNam]

export const routeCustom = (): RouteCustom[] => DANH_SACH_GOI_CUSTOM_FE.flatMap((g) => g.routes ?? [])
export const navCustom = (): NavItem[] => DANH_SACH_GOI_CUSTOM_FE.flatMap((g) => g.nav ?? [])

/** Khe giao diện đầu tiên có đăng ký (null = không khách nào cung cấp). */
export function kheCustom<K extends keyof NonNullable<GoiCustomFE['khe']>>(k: K): NonNullable<GoiCustomFE['khe']>[K] | null {
  for (const g of DANH_SACH_GOI_CUSTOM_FE) { const kh = g.khe?.[k]; if (kh) return kh }
  return null
}
